import "../App.css";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "@fontsource/open-sans";
import "@fontsource/open-sans/400.css";
import "@fontsource/open-sans/400-italic.css";
import { connect } from "react-redux";
import logo from "../logo.png";
import { FaPlay } from "react-icons/fa";
import {
  FiChevronRight,
  FiImage,
  FiClock,
  FiSettings,
  FiChevronUp,
  FiChevronDown,
  FiX,
  FiDownload,
} from "react-icons/fi";
import { VscThreeBars } from "react-icons/vsc";
import { Collapse } from "react-collapse";
import { toast } from "wc-toast";
import { db } from "../config";
import { SetId } from "./redux/actions";

import topLeftPromoImage from "../assets/tv_left.png";
import topRightPromoImage from "../assets/right_box.png";

const userdb = db.ref("userdb");

function Welcome({ items, SetId }) {
  const key = items.myid == null ? null : items.myid.id;
  const navigate = useNavigate();

  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [aiOpen, setAiOpen] = useState(false);
  const [headerCollapsed, setHeaderCollapsed] = useState(false);
  const [apkModalOpen, setApkModalOpen] = useState(false);
  const [downloadingApk, setDownloadingApk] = useState(false);

  const [isdevice_available, setIsDeviceAvailable] = useState(false);

  const [iscontent_available, setIsContentAvailable] = useState(false);
  const [isAi_available, setIsAiAvailable] = useState(false);

  console.log('Is device ...', isdevice_available)

  useEffect(() => {
    if (key != null) {
      const subscribe = userdb
        .child(String(key))
        .on("value", (snapshot) => {
          if (snapshot != null && snapshot.val() != null) {
            if (snapshot.val().devices === undefined) {
              setIsDeviceAvailable(false);
            } else {
              setIsDeviceAvailable(true);
            }


            if (snapshot.val().content === undefined) {
              setIsContentAvailable(false);
            } else {
              setIsContentAvailable(true);
            }
          }
          else if (snapshot != undefined && snapshot != null) {
            setIsDeviceAvailable(false);
            setIsContentAvailable(false);
          }
        });

      return () => subscribe();
    }
  }, [key]);


  useEffect(() => {
    const subscribe = db.ref(`ai_settings/${key}`).on("value", (snapshot) => {
      if (snapshot != undefined && snapshot.exists()) {
        setIsAiAvailable(true);
      } else if (snapshot != undefined) {
        setIsAiAvailable(false);
      }
    });

    return () => {
      subscribe();
    };
  }, [key]);

  useEffect(() => {
    const windowSizeHandler = () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    };

    window.addEventListener("resize", windowSizeHandler);
    return () => {
      window.removeEventListener("resize", windowSizeHandler);
    };
  }, []);

  const isMobile = width <= 768;
  const drawerW = isMobile ? width * 0.8 : width * 0.2;

  const displayName =
    items?.myid?.Name && typeof items.myid.Name === "string"
      ? items.myid.Name.split(" ")[0]
      : "Loram";

  const YOUTUBE_VIDEO_URL = "https://m.youtube.com/watch?v=c0QqGl6dTXc";

  // Replace with your real Firebase Storage direct download URL
  const APK_DOWNLOAD_URL =
    "https://firebasestorage.googleapis.com/v0/b/boomdisplays-3e87d.appspot.com/o/BoomStick.apk?alt=media&token=d83013ef-6253-4c2d-848d-3393249867e0";

  const getYouTubeEmbedUrl = (url) => {
    if (!url) return "";
    const regExp =
      /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/;
    const match = url.match(regExp);
    if (!match || !match[1]) return "";
    return `https://www.youtube.com/embed/${match[1]}?rel=0&modestbranding=1&playsinline=1`;
  };

  const youtubeEmbedUrl = getYouTubeEmbedUrl(YOUTUBE_VIDEO_URL);

  useEffect(() => {
    if (items.myid == null) {
      let obj = localStorage.getItem("display");
      if (obj != null) {
        obj = JSON.parse(obj);
        SetId(obj);
      } else {
        navigate("/");
      }
    }
  }, [items, SetId, navigate]);

  useEffect(() => {
    if (apkModalOpen || drawerOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [apkModalOpen, drawerOpen]);

  const handleDownloadApk = async () => {
    if (
      !APK_DOWNLOAD_URL ||
      APK_DOWNLOAD_URL === "PASTE_YOUR_FIREBASE_STORAGE_DOWNLOAD_LINK_HERE"
    ) {
      toast("Please add your Firebase Storage APK download link first.");
      return;
    }

    try {
      setDownloadingApk(true);

      const response = await fetch(APK_DOWNLOAD_URL, {
        method: "GET",
      });

      if (!response.ok) {
        throw new Error(`Download failed with status ${response.status}`);
      }

      const blob = await response.blob();

      if (!blob || blob.size === 0) {
        throw new Error("APK file is empty or could not be read.");
      }

      const blobUrl = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = "BoomDisplayApp.apk";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      setTimeout(() => {
        window.URL.revokeObjectURL(blobUrl);
      }, 1000);

      toast("BoomDisplayApp.apk download started.");
    } catch (error) {
      console.error("APK download error:", error);

      try {
        const a = document.createElement("a");
        a.href = APK_DOWNLOAD_URL;
        a.target = "_blank";
        a.rel = "noopener noreferrer";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        toast("Opened APK download link.");
      } catch (fallbackError) {
        console.error("Fallback download error:", fallbackError);
        toast("Failed to download APK. Please try again.");
      }
    } finally {
      setDownloadingApk(false);
    }
  };

  const tasks = [
    {
      title: "Add a Device.",
      desc: "Connect your Device with this dashboard, then control your Screen.",
      active: isdevice_available,
      countable: true,
    },
    {
      title: "Add a Content.",
      desc: "Add your first content from your local file. You can add poster & Video content.",
      active: iscontent_available,
      countable: true,
    },
    {
      title: "Set up your Ai for content generation.",
      desc: "Set up your AI to generate content automatically. It will help you create right content for your Business.",
      active: isAi_available,
      countable: true,
    },
  ];

  const progressCount =
    (isdevice_available ? 1 : 0) +
    (iscontent_available ? 1 : 0) +
    (isAi_available ? 1 : 0);

  const progressPercent = Math.min((progressCount / 3) * 100, 100);

  const topCardStyle = {
    borderRadius: 20,
    background: "linear-gradient(180deg, #04080D 0%, #03070B 100%)",
    border: "1px solid rgba(255,255,255,0.07)",
    overflow: "hidden",
    boxSizing: "border-box",
    boxShadow: "0 18px 45px rgba(0,0,0,0.16)",
  };

  const sectionCardStyle = {
    borderRadius: 20,
    background:
      "linear-gradient(180deg, rgba(18,25,36,0.98) 0%, rgba(11,17,26,0.98) 100%)",
    border: "1px solid rgba(255,255,255,0.07)",
    boxSizing: "border-box",
    boxShadow: "0 16px 38px rgba(0,0,0,0.14)",
  };

  const ctaButtonStyle = (filled = true) => ({
    minWidth: filled ? 180 : 154,
    height: 46,
    borderRadius: 999,
    border: filled ? "none" : "1.5px solid #F5A623",
    background: filled ? "#F5A623" : "transparent",
    color: filled ? "#000000" : "#F5A623",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    padding: "0 18px",
    fontFamily: "Open Sans",
    fontWeight: 700,
    fontSize: 15,
    cursor: "pointer",
    boxSizing: "border-box",
    whiteSpace: "nowrap",
  });

  const taskCardStyle = (active) => ({
    width: "100%",
    borderRadius: 15,
    border: active
      ? "1px solid rgba(245,166,35,0.42)"
      : "1px solid rgba(245,166,35,0.16)",
    background: active
      ? "linear-gradient(180deg, rgba(63,40,18,0.76) 0%, rgba(47,31,17,0.74) 100%)"
      : "linear-gradient(180deg, rgba(25,31,38,0.72) 0%, rgba(18,23,30,0.72) 100%)",
    padding: isMobile ? "13px 14px" : "14px 15px",
    boxSizing: "border-box",
    opacity: active ? 1 : 0.68,
    transition: "all 0.22s ease",
  });

  const mobileDrawerTitleStyle = (maxW) => ({
    color: "white",
    marginLeft: 18,
    fontWeight: "600",
    fontSize: 15,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: maxW,
    display: "block",
  });

  const headerActionIconStyle = {
    width: isMobile ? 38 : 42,
    height: isMobile ? 38 : 42,
    borderRadius: 999,
    border: "1px solid rgba(245,166,35,0.24)",
    background: "rgba(245,166,35,0.08)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    flexShrink: 0,
    transition: "all 0.25s ease",
    boxShadow: "0 8px 18px rgba(0,0,0,0.18)",
  };

  const modalCardStyle = {
    width: "100%",
    maxWidth: isMobile ? 540 : 790,
    background:
      "linear-gradient(180deg, rgba(8,8,8,0.98) 0%, rgba(3,3,3,0.98) 100%)",
    border: "1.5px solid rgba(247,148,29,0.72)",
    borderRadius: isMobile ? 18 : 20,
    padding: isMobile ? "26px 20px 22px" : "34px 34px 28px",
    boxSizing: "border-box",
    boxShadow:
      "0 30px 80px rgba(0,0,0,0.55), 0 0 0 1px rgba(247,148,29,0.08) inset",
    position: "relative",
    overflow: "hidden",
  };

  const modalTextStyle = {
    textAlign: "left",
    color: "rgba(255,255,255,0.90)",
    fontFamily: "Open Sans",
  };

  const AiSubItem = ({ icon, label, onClick }) => (
    <div
      onClick={onClick}
      style={{
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        gap: 14,
        height: 52,
        paddingLeft: 18,
        paddingRight: 20,
        marginBottom: 8,
        borderRadius: 12,
        backgroundColor: "transparent",
      }}
    >
      <div
        style={{
          width: 22,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#9AA4B2",
        }}
      >
        {icon}
      </div>

      <span
        style={{
          fontSize: label === "Create Images" ? 13 : 15,
          fontWeight: 600,
          lineHeight: "1",
          color: "#9AA4B2",
          textAlign: "left",
          whiteSpace: "nowrap",
        }}
      >
        {label}
      </span>
    </div>
  );

  const AiLeftSubMenuDesktop = () => {
    return (
      <div
        style={{
          display: "flex",
          width: width * 0.14,
          marginTop: 8,
          marginLeft: 52,
        }}
      >
        <div
          style={{
            width: 4,
            backgroundColor: "#2E3642",
            borderRadius: 4,
            marginRight: 14,
          }}
        />

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <AiSubItem
            icon={<FiImage />}
            label="Create Images"
            onClick={() => {
              if (items.devices > 0) {
                navigate("/AICreate");
              } else {
                toast("Add a Boom Display Device before using Ai");
              }
            }}
          />

          <AiSubItem
            icon={<FiClock />}
            label="History"
            onClick={() => navigate("/AIGenerator")}
          />

          <AiSubItem
            icon={<FiSettings />}
            label="Settings"
            onClick={() => navigate("/AISetting")}
          />
        </div>
      </div>
    );
  };

  const AiLeftSubMenuMobile = () => {
    return (
      <div
        style={{
          display: "flex",
          width: width * 0.35,
          alignSelf: "center",
          marginTop: 8,
        }}
      >
        <div
          style={{
            width: 4,
            backgroundColor: "#2E3642",
            borderRadius: 4,
            marginRight: 14,
            marginLeft: 12,
          }}
        />

        <div style={{ flex: 1 }}>
          <AiSubItem
            icon={<FiImage />}
            label="Create Images"
            onClick={() => navigate("/AICreate")}
          />

          <AiSubItem
            icon={<FiClock />}
            label="History"
            onClick={() => navigate("/AIGenerator")}
          />

          <AiSubItem
            icon={<FiSettings />}
            label="Settings"
            onClick={() => navigate("/AISetting")}
          />
        </div>
      </div>
    );
  };

  const SidebarDesktop = () => (
    <div
      style={{
        backgroundColor: "#080A0C",
        position: "fixed",
        top: 0,
        left: 0,
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        width: width * 0.2,
        textAlign: "center",
        overflowY: "auto",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#080A0C",
          width: width * 0.2,
          height: 100,
          justifyContent: "center",
          alignItems: "center",
          flexShrink: 0,
        }}
      >
        <img
          src={logo}
          alt="Logo"
          style={{ width: 113, marginTop: 1, height: 53, alignSelf: "center" }}
        />
      </div>

      <div
        style={{
          marginTop: 20,
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          width: 0.18 * width,
          padding: 10,
          alignSelf: "center",
          alignItems: "center",
          height: 52,
        }}
      >
        <div
          style={{
            backgroundColor: "#181E25",
            width: 0.14 * width,
            flexDirection: "row",
            display: "flex",
            padding: 10,
            borderRadius: 6,
            height: 52,
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <text
            style={{
              color: "white",
              marginLeft: 30,
              fontWeight: "600",
              fontSize: 16,
            }}
          >
            Welcome
          </text>
          <img
            src={require("../assets/right.png")}
            style={{ height: 41, width: 20 }}
          />
        </div>
      </div>

      <div
        onClick={() => navigate("/Devices")}
        style={{
          cursor: "pointer",
          marginTop: 5,
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          width: 0.18 * width,
          padding: 10,
          alignSelf: "center",
          alignItems: "center",
          height: 52,
        }}
      >
        <div
          style={{
            width: 0.14 * width,
            flexDirection: "row",
            display: "flex",
            padding: 10,
            borderRadius: 6,
            height: 52,
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <text
            style={{
              color: "white",
              marginLeft: 30,
              fontWeight: "600",
              fontSize: 16,
            }}
          >
            Devices
          </text>
          <div style={{ height: 41, width: 20 }} />
        </div>
      </div>

      <div
        onClick={() => navigate("/Content")}
        style={{
          cursor: "pointer",
          marginTop: 5,
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          width: 0.18 * width,
          padding: 10,
          alignSelf: "center",
          alignItems: "center",
          height: 52,
        }}
      >
        <div
          style={{
            width: 0.14 * width,
            flexDirection: "row",
            display: "flex",
            padding: 10,
            borderRadius: 6,
            height: 52,
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <text
            style={{
              color: "white",
              marginLeft: 30,
              fontWeight: "600",
              fontSize: 16,
            }}
          >
            Content
          </text>
          <div style={{ height: 41, width: 20 }} />
        </div>
      </div>

      <div
        onClick={() => navigate("/Calendars")}
        style={{
          cursor: "pointer",
          marginTop: 5,
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          width: 0.18 * width,
          padding: 10,
          alignSelf: "center",
          alignItems: "center",
          height: 52,
        }}
      >
        <div
          style={{
            width: 0.14 * width,
            flexDirection: "row",
            display: "flex",
            padding: 10,
            borderRadius: 6,
            height: 52,
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <text
            style={{
              color: "white",
              marginLeft: 30,
              fontWeight: "600",
              fontSize: 16,
            }}
          >
            Calendar
          </text>
          <div style={{ height: 41, width: 20 }} />
        </div>
      </div>

      <div
        onClick={() => setAiOpen(!aiOpen)}
        style={{
          cursor: "pointer",
          marginTop: 5,
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          width: 0.18 * width,
          padding: 10,
          alignSelf: "center",
          alignItems: "center",
          height: 52,
        }}
      >
        <div
          style={{
            width: 0.14 * width,
            flexDirection: "row",
            display: "flex",
            padding: 10,
            borderRadius: 6,
            height: 52,
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <text
            style={{
              color: "white",
              marginLeft: 30,
              fontWeight: "600",
              fontSize: 16,
            }}
          >
            AI Generator
          </text>

          <img
            src={require("../assets/right.png")}
            style={{
              height: 41,
              width: 20,
              transform: aiOpen ? "rotate(90deg)" : "rotate(0deg)",
              transition: "transform 200ms ease",
            }}
          />
        </div>
      </div>

      <Collapse isOpened={aiOpen}>
        <AiLeftSubMenuDesktop />
      </Collapse>

      <div
        onClick={() => navigate("/Subscription")}
        style={{
          cursor: "pointer",
          marginTop: 5,
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          width: 0.18 * width,
          padding: 10,
          alignSelf: "center",
          alignItems: "center",
          height: 52,
        }}
      >
        <div
          style={{
            position: "relative",
            width: 0.14 * width,
            flexDirection: "row",
            display: "flex",
            padding: 10,
            borderRadius: 6,
            height: 52,
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <text
            style={{
              color: "white",
              marginLeft: 30,
              fontWeight: "600",
              fontSize: 16,
            }}
          >
            Subscription
          </text>
          <div style={{ height: 41, width: 20 }} />
          {items.unlicensed > 0 && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "absolute",
                height: 20,
                width: 20,
                borderRadius: 12,
                backgroundColor: "white",
                borderWidth: 2,
                borderStyle: "solid",
                borderColor: "red",
                top: 5,
                left: 5,
              }}
            >
              <text style={{ color: "red", fontSize: 13 }}>
                {items.unlicensed}
              </text>
            </div>
          )}
          {items.trial > 0 && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "absolute",
                height: 20,
                width: 20,
                borderRadius: 12,
                backgroundColor: "white",
                borderWidth: 2,
                borderStyle: "solid",
                borderColor: "#F7941D",
                top: 5,
                right: 20,
              }}
            >
              <text style={{ color: "#F7941D", fontSize: 13 }}>
                {items.trial}
              </text>
            </div>
          )}
        </div>
      </div>

      <div
        onClick={() => navigate("/Settings")}
        style={{
          cursor: "pointer",
          marginTop: 5,
          marginBottom: 20,
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          width: 0.18 * width,
          padding: 10,
          alignSelf: "center",
          alignItems: "center",
          height: 52,
        }}
      >
        <div
          style={{
            width: 0.14 * width,
            flexDirection: "row",
            display: "flex",
            padding: 10,
            borderRadius: 6,
            height: 52,
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <text
            style={{
              color: "white",
              marginLeft: 30,
              fontWeight: "600",
              fontSize: 16,
            }}
          >
            Settings
          </text>
          <div style={{ height: 41, width: 20 }} />
        </div>
      </div>
    </div>
  );

  const SidebarMobile = () => (
    <div
      className={drawerOpen ? "side-drawer open" : "side-drawer"}
      style={{ width: drawerW, zIndex: 30 }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          backgroundColor: "#080A0C",
          width: drawerW,
          height: 60,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          src={logo}
          alt="Logo"
          style={{ width: 113, marginTop: 1, height: 53, alignSelf: "center" }}
        />
      </div>

      <div
        style={{
          marginTop: 10,
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          width: drawerW - 30,
          padding: 10,
          alignSelf: "center",
          alignItems: "center",
          height: 30,
        }}
      >
        <div
          style={{
            backgroundColor: "#181E25",
            width: drawerW - 42,
            flexDirection: "row",
            display: "flex",
            padding: 10,
            borderRadius: 6,
            height: 30,
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <text style={mobileDrawerTitleStyle(drawerW - 32 - 46)}>
            Welcome
          </text>
          <img
            src={require("../assets/right.png")}
            style={{ height: 30, width: 20 }}
          />
        </div>
      </div>

      <div
        onClick={() => navigate("/Devices")}
        style={{
          cursor: "pointer",
          marginTop: 5,
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          width: drawerW,
          padding: 10,
          alignSelf: "center",
          alignItems: "center",
          height: 30,
        }}
      >
        <div
          style={{
            width: drawerW - 22,
            flexDirection: "row",
            display: "flex",
            padding: 10,
            borderRadius: 6,
            height: 36,
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <text style={mobileDrawerTitleStyle(drawerW - 22 - 46)}>
            Devices
          </text>
          <div style={{ height: 30, width: 20 }} />
        </div>
      </div>

      <div
        onClick={() => navigate("/Content")}
        style={{
          cursor: "pointer",
          marginTop: 5,
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          width: drawerW,
          padding: 10,
          alignSelf: "center",
          alignItems: "center",
          height: 30,
        }}
      >
        <div
          style={{
            width: drawerW - 22,
            flexDirection: "row",
            display: "flex",
            padding: 10,
            borderRadius: 6,
            height: 36,
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <text style={mobileDrawerTitleStyle(drawerW - 22 - 46)}>
            Content
          </text>
          <div style={{ height: 30, width: 20 }} />
        </div>
      </div>

      <div
        onClick={() => navigate("/Calendars")}
        style={{
          cursor: "pointer",
          marginTop: 5,
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          width: drawerW,
          padding: 10,
          alignSelf: "center",
          alignItems: "center",
          height: 30,
        }}
      >
        <div
          style={{
            width: drawerW - 22,
            flexDirection: "row",
            display: "flex",
            padding: 10,
            borderRadius: 6,
            height: 36,
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <text style={mobileDrawerTitleStyle(drawerW - 22 - 46)}>
            Calendar
          </text>
          <div style={{ height: 30, width: 20 }} />
        </div>
      </div>

      <div
        onClick={() => setAiOpen(!aiOpen)}
        style={{
          cursor: "pointer",
          marginTop: 5,
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          width: drawerW,
          padding: 10,
          alignSelf: "center",
          alignItems: "center",
          height: 30,
        }}
      >
        <div
          style={{
            width: drawerW - 22,
            flexDirection: "row",
            display: "flex",
            padding: 10,
            borderRadius: 6,
            height: 36,
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <text style={mobileDrawerTitleStyle(drawerW - 22 - 46)}>
            AI Generator
          </text>

          <img
            src={require("../assets/right.png")}
            style={{
              height: 30,
              width: 20,
              transform: aiOpen ? "rotate(90deg)" : "rotate(0deg)",
              transition: "transform 200ms ease",
            }}
          />
        </div>
      </div>

      <Collapse isOpened={aiOpen}>
        <AiLeftSubMenuMobile />
      </Collapse>

      <div
        onClick={() => navigate("/Subscription")}
        style={{
          cursor: "pointer",
          marginTop: 5,
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          width: drawerW,
          padding: 10,
          alignSelf: "center",
          alignItems: "center",
          height: 30,
        }}
      >
        <div
          style={{
            position: "relative",
            width: drawerW - 22,
            flexDirection: "row",
            display: "flex",
            padding: 10,
            borderRadius: 6,
            height: 36,
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <text style={mobileDrawerTitleStyle(drawerW - 22 - 46)}>
            Subscription
          </text>
          <div style={{ height: 30, width: 20 }} />
          {items.unlicensed > 0 && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "absolute",
                height: 20,
                width: 20,
                borderRadius: 12,
                backgroundColor: "white",
                borderWidth: 2,
                borderStyle: "solid",
                borderColor: "red",
                top: 5,
                left: 5,
              }}
            >
              <text style={{ color: "red", fontSize: 13 }}>
                {items.unlicensed}
              </text>
            </div>
          )}
          {items.trial > 0 && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "absolute",
                height: 20,
                width: 20,
                borderRadius: 12,
                backgroundColor: "white",
                borderWidth: 2,
                borderStyle: "solid",
                borderColor: "#F7941D",
                top: 5,
                right: 20,
              }}
            >
              <text style={{ color: "#F7941D", fontSize: 13 }}>
                {items.trial}
              </text>
            </div>
          )}
        </div>
      </div>

      <div
        onClick={() => navigate("/Settings")}
        style={{
          cursor: "pointer",
          marginTop: 5,
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          width: drawerW,
          padding: 10,
          alignSelf: "center",
          alignItems: "center",
          height: 30,
        }}
      >
        <div
          style={{
            width: drawerW - 22,
            flexDirection: "row",
            display: "flex",
            padding: 10,
            borderRadius: 6,
            height: 36,
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <text style={mobileDrawerTitleStyle(drawerW - 22 - 46)}>
            Settings
          </text>
          <div style={{ height: 30, width: 20 }} />
        </div>
      </div>
    </div>
  );

  const DesktopModal = () =>
    apkModalOpen ? (
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.58)",
          backdropFilter: "blur(7px)",
          WebkitBackdropFilter: "blur(7px)",
          zIndex: 1000,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 20,
          boxSizing: "border-box",
        }}
        onClick={() => setApkModalOpen(false)}
      >
        <div onClick={(e) => e.stopPropagation()} style={modalCardStyle}>
          <div
            style={{
              position: "absolute",
              inset: 0,
              background:
                "radial-gradient(circle at top right, rgba(247,148,29,0.12) 0%, rgba(247,148,29,0.04) 22%, rgba(0,0,0,0) 48%)",
              pointerEvents: "none",
            }}
          />

          <div
            onClick={() => setApkModalOpen(false)}
            style={{
              position: "absolute",
              top: 16,
              right: 16,
              width: 38,
              height: 38,
              borderRadius: 999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              background: "rgba(255,255,255,0.05)",
              border: "1px solid rgba(255,255,255,0.08)",
              zIndex: 2,
            }}
          >
            <FiX color="#FFFFFF" size={20} />
          </div>

          <div
            style={{
              ...modalTextStyle,
              position: "relative",
              zIndex: 1,
            }}
          >
            <div
              style={{
                color: "#FFFFFF",
                fontSize: 26,
                lineHeight: "36px",
                fontWeight: 700,
                fontFamily: "Open Sans",
                maxWidth: 620,
                textAlign: "left",
              }}
            >
              Try Boom Display on Your
              <br />
              <span style={{ color: "#F7941D", fontSize: 28 }}>
                Own Android Device.
              </span>
            </div>

            <div
              style={{
                marginTop: 22,
                color: "rgba(255,255,255,0.86)",
                fontSize: 16,
                lineHeight: "29px",
                fontFamily: "Open Sans",
                maxWidth: 650,
                textAlign: "left",
              }}
            >
              Want to see how{" "}
              <span style={{ color: "#F7941D", fontWeight: 700 }}>
                Boom Display
              </span>{" "}
              works before setting up hardware? Download our app and instantly
              simulate the Boom Display experience on your personal device.
            </div>

            <div
              style={{
                marginTop: 28,
                color: "#F7941D",
                fontSize: 16,
                fontWeight: 700,
                fontFamily: "Open Sans",
                textAlign: "left",
              }}
            >
              What you can do:
            </div>

            <div
              style={{
                marginTop: 10,
                color: "rgba(255,255,255,0.88)",
                fontSize: 15.5,
                lineHeight: "29px",
                fontFamily: "Open Sans",
                textAlign: "left",
              }}
            >
              • Turn your{" "}
              <span style={{ fontWeight: 700, color: "#FFFFFF" }}>
                android phone
              </span>{" "}
              or{" "}
              <span style={{ fontWeight: 700, color: "#FFFFFF" }}>
                android smart TV
              </span>{" "}
              into a Boom Display screen
              <br />
              • Preview your content in real-time
              <br />
              • Test layouts, media, and playback behavior
              <br />
              • No HDMI stick or external device required
            </div>

            <div
              style={{
                marginTop: 28,
                color: "#FFFFFF",
                fontSize: 17,
                lineHeight: "31px",
                fontWeight: 700,
                fontFamily: "Open Sans",
                textAlign: "left",
              }}
            >
              Free <span style={{ color: "#F7941D" }}>7-day trial</span>{" "}
              included. Just download and start exploring.
            </div>

            <div
              style={{
                marginTop: 30,
                color: "#F7941D",
                fontSize: 16,
                fontWeight: 700,
                fontFamily: "Open Sans",
                textAlign: "left",
              }}
            >
              Supported Devices:
            </div>

            <div
              style={{
                marginTop: 10,
                color: "rgba(255,255,255,0.88)",
                fontSize: 15.5,
                lineHeight: "29px",
                fontFamily: "Open Sans",
                textAlign: "left",
              }}
            >
              • Android smartphones & tablets
              <br />
              • Android Smart TVs
            </div>

            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-start",
                marginTop: 34,
              }}
            >
              <button
                onClick={handleDownloadApk}
                disabled={downloadingApk}
                style={{
                  minWidth: 188,
                  height: 48,
                  borderRadius: 999,
                  border: "none",
                  background: "#F7941D",
                  color: "#000000",
                  fontWeight: 700,
                  fontSize: 15,
                  fontFamily: "Open Sans",
                  cursor: downloadingApk ? "default" : "pointer",
                  opacity: downloadingApk ? 0.7 : 1,
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 10,
                  boxShadow: "0 10px 22px rgba(247,148,29,0.22)",
                }}
              >
                {downloadingApk ? "Downloading..." : "Download APK"}
                <FiDownload size={16} />
              </button>
            </div>
          </div>
        </div>
      </div>
    ) : null;

  const MobileModal = () =>
    apkModalOpen ? (
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.60)",
          backdropFilter: "blur(7px)",
          WebkitBackdropFilter: "blur(7px)",
          zIndex: 1000,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: 14,
          boxSizing: "border-box",
        }}
        onClick={() => setApkModalOpen(false)}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            ...modalCardStyle,
            maxHeight: "92vh",
            overflowY: "auto",
          }}
        >
          <div
            style={{
              position: "absolute",
              inset: 0,
              background:
                "radial-gradient(circle at top right, rgba(247,148,29,0.12) 0%, rgba(247,148,29,0.04) 22%, rgba(0,0,0,0) 48%)",
              pointerEvents: "none",
            }}
          />

          <div
            onClick={() => setApkModalOpen(false)}
            style={{
              position: "absolute",
              top: 12,
              right: 12,
              width: 34,
              height: 34,
              borderRadius: 999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              background: "rgba(255,255,255,0.05)",
              border: "1px solid rgba(255,255,255,0.08)",
              zIndex: 2,
            }}
          >
            <FiX color="#FFFFFF" size={18} />
          </div>

          <div
            style={{
              ...modalTextStyle,
              position: "relative",
              zIndex: 1,
              marginTop: 4,
            }}
          >
            <div
              style={{
                color: "#FFFFFF",
                fontSize: 24,
                lineHeight: "32px",
                fontWeight: 700,
                fontFamily: "Open Sans",
                textAlign: "left",
              }}
            >
              Try Boom Display on Your
              <br />
              <span style={{ color: "#F7941D" }}>Own Android Device.</span>
            </div>

            <div
              style={{
                marginTop: 18,
                color: "rgba(255,255,255,0.86)",
                fontSize: 14.5,
                lineHeight: "25px",
                fontFamily: "Open Sans",
                textAlign: "left",
              }}
            >
              Want to see how{" "}
              <span style={{ color: "#F7941D", fontWeight: 700 }}>
                Boom Display
              </span>{" "}
              works before setting up hardware? Download our app and instantly
              simulate the Boom Display experience on your personal device.
            </div>

            <div
              style={{
                marginTop: 22,
                color: "#F7941D",
                fontSize: 15.5,
                fontWeight: 700,
                fontFamily: "Open Sans",
                textAlign: "left",
              }}
            >
              What you can do:
            </div>

            <div
              style={{
                marginTop: 8,
                color: "rgba(255,255,255,0.88)",
                fontSize: 14,
                lineHeight: "24px",
                fontFamily: "Open Sans",
                textAlign: "left",
              }}
            >
              • Turn your{" "}
              <span style={{ fontWeight: 700, color: "#FFFFFF" }}>
                android phone
              </span>{" "}
              or{" "}
              <span style={{ fontWeight: 700, color: "#FFFFFF" }}>
                android smart TV
              </span>{" "}
              into a Boom Display screen
              <br />
              • Preview your content in real-time
              <br />
              • Test layouts, media, and playback behavior
              <br />
              • No HDMI stick or external device required
            </div>

            <div
              style={{
                marginTop: 22,
                color: "#FFFFFF",
                fontSize: 16,
                lineHeight: "28px",
                fontWeight: 700,
                fontFamily: "Open Sans",
                textAlign: "left",
              }}
            >
              Free <span style={{ color: "#F7941D" }}>7-day trial</span>{" "}
              included. Just download and start exploring.
            </div>

            <div
              style={{
                marginTop: 22,
                color: "#F7941D",
                fontSize: 15.5,
                fontWeight: 700,
                fontFamily: "Open Sans",
                textAlign: "left",
              }}
            >
              Supported Devices:
            </div>

            <div
              style={{
                marginTop: 8,
                color: "rgba(255,255,255,0.88)",
                fontSize: 14,
                lineHeight: "24px",
                fontFamily: "Open Sans",
                textAlign: "left",
              }}
            >
              • Android smartphones & tablets
              <br />
              • Android Smart TVs
            </div>

            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-start",
                marginTop: 26,
              }}
            >
              <button
                onClick={handleDownloadApk}
                disabled={downloadingApk}
                style={{
                  minWidth: 176,
                  height: 46,
                  borderRadius: 999,
                  border: "none",
                  background: "#F7941D",
                  color: "#000000",
                  fontWeight: 700,
                  fontSize: 14,
                  fontFamily: "Open Sans",
                  cursor: downloadingApk ? "default" : "pointer",
                  opacity: downloadingApk ? 0.7 : 1,
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 10,
                  boxShadow: "0 10px 22px rgba(247,148,29,0.22)",
                }}
              >
                {downloadingApk ? "Downloading..." : "Download APK"}
                <FiDownload size={15} />
              </button>
            </div>
          </div>
        </div>
      </div>
    ) : null;

  const videoCardHeightDesktop = headerCollapsed ? 468 : 390;
  const videoCardHeightMobile = headerCollapsed ? 364 : 300;

  const promoImageBoxStyle = {
    width: "100%",
    height: 130,
    borderRadius: 1,
    // border: "1px solid rgba(255,255,255,0.08)",
    overflow: "hidden",
    // background: "linear-gradient(180deg, #10151C 0%, #0B1016 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const promoImageStyle = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
  };

  const videoDescriptionCardStyle = {
    width: "100%",
    minWidth: 0,
    marginTop: 0,
    flexShrink: 0,
    borderRadius: 22,
    background:
      "linear-gradient(180deg, rgba(39,46,58,0.96) 0%, rgba(31,37,47,0.96) 100%)",
    border: "1px solid rgba(255,255,255,0.10)",
    padding: isMobile ? "18px 18px 20px" : "18px 20px 20px",
    boxSizing: "border-box",
    boxShadow: "0 18px 34px rgba(0,0,0,0.18)",
    textAlign: "left",
  };

  const videoDescriptionTitleStyle = {
    display: "flex",
    alignItems: "center",
    gap: 14,
    color: "#FFFFFF",
    fontFamily: "Open Sans",
    fontWeight: 800,
    fontSize: isMobile ? 17 : 18,
    textAlign: "left",
  };

  const videoDescriptionTextStyle = {
    marginTop: 10,
    color: "rgba(255,255,255,0.92)",
    fontFamily: "Open Sans",
    fontSize: isMobile ? 12 : 14,
    lineHeight: isMobile ? "20px" : "25px",
    fontWeight: 400,
    textAlign: "left",
    letterSpacing: "0.1px",
  };

  return !isMobile ? (
    <div
      style={{
        width: "100%",
        minHeight: "100vh",
        height: "100vh",
        backgroundColor: "#080A0C",
        display: "flex",
        flexDirection: "row",
        overflow: "hidden",
      }}
    >
      <DesktopModal />
      <SidebarDesktop />

      <div
        style={{
          width: width * 0.8,
          marginLeft: width * 0.2,
          height: "100vh",
          background: "linear-gradient(180deg, #161E29 0%, #131A23 100%)",
          boxSizing: "border-box",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "100%",
            padding: "16px 18px 18px",
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            gap: 16,
          }}
        >
          <div
            style={{
              ...topCardStyle,
              width: "100%",
              minHeight: headerCollapsed ? 84 : 190,
              display: "grid",
              gridTemplateColumns: "1fr",
              position: "relative",
              transition: "min-height 0.35s ease",
              flexShrink: 0,
            }}
          >
            <div
              onClick={() => setHeaderCollapsed(!headerCollapsed)}
              style={{
                ...headerActionIconStyle,
                position: "absolute",
                top: 14,
                right: 14,
                zIndex: 3,
              }}
            >
              {headerCollapsed ? (
                <FiChevronDown size={18} color="#F5A623" />
              ) : (
                <FiChevronUp size={18} color="#F5A623" />
              )}
            </div>

            <div
              style={{
                width: "100%",
                transition: "all 0.35s ease",
                overflow: "hidden",
                maxHeight: headerCollapsed ? 0 : 260,
                opacity: headerCollapsed ? 0 : 1,
              }}
            >
              <div
                style={{
                  width: "100%",
                  minHeight: 190,
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                }}
              >
                <div
                  style={{
                    padding: 22,
                    boxSizing: "border-box",
                    display: "grid",
                    gridTemplateColumns: "240px 1fr",
                    gap: 16,
                    alignItems: "center",
                    borderRight: "1px solid rgba(255,255,255,0.05)",
                  }}
                >
                  <div style={promoImageBoxStyle}>
                    <img
                      src={topLeftPromoImage}
                      alt="Try it out on android device"
                      style={promoImageStyle}
                    />
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    <div
                      style={{
                        color: "#FFFFFF",
                        fontSize: 30,
                        fontWeight: 800,
                        fontFamily: "Open Sans",
                        lineHeight: "38px",
                      }}
                    >
                      Download <span style={{ color: "#F5A623" }}>APK</span>
                    </div>

                    <div
                      style={{
                        marginTop: 8,
                        color: "#F0F0F0",
                        fontSize: 20,
                        fontWeight: 400,
                        fontFamily: "Open Sans",
                        lineHeight: "30px",
                        maxWidth: 260,
                        textAlign: "left",
                        alignSelf: "flex-start",
                      }}
                    >
                      Try it out on any{" "}
                      <span style={{ color: "#F5A623", fontWeight: 700 }}>
                        android
                      </span>{" "}
                      device.
                    </div>

                    <div
                      onClick={() => setApkModalOpen(true)}
                      style={{
                        ...ctaButtonStyle(true),
                        marginTop: 18,
                      }}
                    >
                      Get 7 days free trial
                      <FiChevronRight size={18} />
                    </div>
                  </div>
                </div>

                <div
                  style={{
                    padding: 22,
                    boxSizing: "border-box",
                    display: "grid",
                    gridTemplateColumns: "1fr 150px",
                    gap: 16,
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    <div
                      style={{
                        color: "#FFFFFF",
                        fontSize: 30,
                        fontWeight: 800,
                        fontFamily: "Open Sans",
                        lineHeight: "38px",
                      }}
                    >
                      Ready to <span style={{ color: "#F5A623" }}>Transform</span>{" "}
                      ?
                    </div>

                    <div
                      style={{
                        marginTop: 10,
                        color: "#F0F0F0",
                        fontSize: 18,
                        fontWeight: 400,
                        fontFamily: "Open Sans",
                        lineHeight: "30px",
                        maxWidth: 330,
                        textAlign: "left",
                        alignSelf: "flex-start",
                      }}
                    >
                      Get a{" "}
                      <span style={{ color: "#F5A623", fontWeight: 700 }}>
                        free HDMI Boom stick
                      </span>{" "}
                      with every subscription!
                    </div>

                    <div
                      onClick={() => navigate("/Subscription")}
                      style={{
                        ...ctaButtonStyle(false),
                        marginTop: 18,
                      }}
                    >
                      Subscribe Now
                      <FiChevronRight size={18} />
                    </div>
                  </div>


                  <div
                    style={{
                      width: 150,
                      height: 150,
                      justifySelf: "end",
                      borderRadius: 14,
                      overflow: "hidden",
                      //  border: "1px solid rgba(255,255,255,0.08)",
                      boxShadow: "0 16px 30px rgba(0,0,0,0.3)",
                      position: "relative",
                      // background: "#11161D",
                    }}
                  >
                    <img
                      src={topRightPromoImage}
                      alt="Free HDMI Boom Stick"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        display: "block",
                      }}
                    />
                  </div>

                </div>
              </div>
            </div>

            {headerCollapsed ? (
              <div
                style={{
                  width: "100%",
                  minHeight: 88,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "0 70px 0 20px",
                  boxSizing: "border-box",
                  gap: 18,
                }}
              >
                <div>
                  <div
                    style={{
                      color: "#FFFFFF",
                      fontSize: 24,
                      fontWeight: 800,
                      fontFamily: "Open Sans",
                      lineHeight: "28px",
                    }}
                  >
                    Welcome
                  </div>
                  <div
                    style={{
                      marginTop: 4,
                      color: "#B9BDC4",
                      fontSize: 14,
                      fontFamily: "Open Sans",
                    }}
                  >
                    Quick overview and video
                  </div>
                </div>

                <div
                  onClick={() => setApkModalOpen(true)}
                  style={{
                    ...ctaButtonStyle(true),
                    minWidth: 182,
                    height: 42,
                    fontSize: 13.5,
                    padding: "0 16px",
                    flexShrink: 0,
                  }}
                >
                  Get 7 days free trial
                </div>
              </div>
            ) : null}
          </div>

          <div
            style={{
              width: "100%",
              flex: 1,
              minHeight: 0,
              display: "grid",
              gridTemplateColumns: "minmax(0, 1fr) 382px",
              gap: 18,
              alignItems: "stretch",
            }}
          >
            <div
              style={{
                width: "100%",
                minHeight: 0,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  color: "#FFFFFF",
                  fontSize: 22,
                  fontWeight: 700,
                  fontFamily: "Open Sans",
                  marginBottom: 12,
                  flexShrink: 0,
                  textAlign: 'left'
                }}
              >
                Hi {displayName}
              </div>

              <div
                style={{
                  ...sectionCardStyle,
                  width: "100%",
                  flex: 1,
                  minHeight: 0,
                  padding: 14,
                  display: "flex",
                  flexDirection: "column",
                  gap: 14,
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    flex: 1,
                    minHeight: 0,
                    borderRadius: 16,
                    position: "relative",
                    overflow: "hidden",
                    background:
                      "radial-gradient(circle at center, rgba(245,166,35,0.18) 0%, rgba(245,166,35,0.03) 28%, rgba(0,0,0,0) 55%), linear-gradient(180deg, #111821 0%, #0D141D 100%)",
                    border: "1px solid rgba(255,255,255,0.08)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {youtubeEmbedUrl ? (
                    <iframe
                      width="100%"
                      height="100%"
                      src={youtubeEmbedUrl}
                      title="Boom Display Welcome Video"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allowFullScreen
                      style={{
                        width: "100%",
                        height: "100%",
                        border: "none",
                        borderRadius: 16,
                        display: "block",
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: "84%",
                        textAlign: "center",
                        color: "#FFFFFF",
                        fontSize: 16,
                        fontFamily: "Open Sans",
                        lineHeight: "28px",
                        opacity: 0.9,
                      }}
                    >
                      Add your YouTube video URL inside{" "}
                      <span style={{ color: "#F5A623", fontWeight: 700 }}>
                        YOUTUBE_VIDEO_URL
                      </span>
                    </div>
                  )}
                </div>

                <div style={videoDescriptionCardStyle}>
                  <div style={videoDescriptionTitleStyle}>
                    <div
                      style={{
                        width: isMobile ? 20 : 26,
                        height: isMobile ? 20 : 26,
                        borderRadius: 999,
                        border: "2px solid #F5A623",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <FaPlay
                        size={isMobile ? 4 : 6}
                        color="#F5A623"
                        style={{ marginLeft: 2 }}
                      />
                    </div>

                    <span style={{ color: "#FFFFFF", fontWeight: 600 }}>
                      Video.
                    </span>

                    <span style={{ color: "rgba(255,255,255,0.55)", fontWeight: 600 }}>
                      3:55
                    </span>
                  </div>

                  <div style={videoDescriptionTextStyle}>
                    Introduction of Boom Display. About whole Interface and Ai generating
                    Images and post.
                  </div>
                </div>

              </div>
            </div>

            <div
              style={{
                ...sectionCardStyle,
                width: "100%",
                height: "100%",
                padding: 18,
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "column",
                minHeight: 0,
              }}
            >
              <div
                style={{
                  color: "#FFFFFF",
                  fontSize: 20,
                  fontWeight: 400,
                  fontFamily: "Open Sans",
                  marginBottom: 12,
                  flexShrink: 0,
                }}
              >
                Lets start with simple tasks
              </div>

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                  color: "#F5A623",
                  fontSize: 14,
                  fontWeight: 700,
                  fontFamily: "Open Sans",
                  marginBottom: 8,
                  flexShrink: 0,
                }}
              >
                {Math.round(progressPercent)}/100
              </div>

              <div
                style={{
                  width: "100%",
                  height: 8,
                  borderRadius: 999,
                  background: "#FFFFFF",
                  overflow: "hidden",
                  marginBottom: 16,
                  flexShrink: 0,
                }}
              >
                <div
                  style={{
                    width: `${progressPercent}%`,
                    height: "100%",
                    borderRadius: 999,
                    background: "#F5A623",
                  }}
                />
              </div>

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: 10,
                  overflowY: "auto",
                  minHeight: 0,
                  paddingRight: 2,
                }}
              >
                {tasks.map((task, index) => (
                  <div onClick={() => {
                    if (index == 0) {
                      navigate('/Devices')
                    }
                    else if (index == 1) {
                      navigate('/Content')
                    }
                    else if (index == 2) {
                      navigate("/AISetting")
                    }
                  }} key={index} style={taskCardStyle(task.active)}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 12,
                        cursor: 'pointer'
                      }}
                    >
                      <div
                        style={{
                          width: 20,
                          height: 20,
                          borderRadius: 999,
                          border: `1.4px solid ${task.active ? "#F5A623" : "rgba(245,166,35,0.55)"
                            }`,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                          marginTop: 2,
                        }}
                      >
                        {task.active ? (
                          <div
                            style={{
                              width: 7,
                              height: 7,
                              borderRadius: 999,
                              background: "#F5A623",
                            }}
                          />
                        ) : null}
                      </div>

                      <div
                        style={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          textAlign: "left",
                        }}
                      >
                        <div
                          style={{
                            width: "100%",
                            color: "#FFFFFF",
                            fontSize: 16,
                            fontWeight: 700,
                            fontFamily: "Open Sans",
                            lineHeight: "22px",
                            textAlign: "left",
                          }}
                        >
                          {task.title}
                        </div>

                        <div
                          style={{
                            width: "100%",
                            marginTop: 5,
                            color: "#D8D8D8",
                            opacity: 0.78,
                            fontSize: 13.5,
                            fontWeight: 400,
                            fontFamily: "Open Sans",
                            lineHeight: "21px",
                            textAlign: "left",
                          }}
                        >
                          {task.desc}
                        </div>
                      </div>

                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <wc-toast></wc-toast>
    </div>
  ) : (
    <div
      style={{
        backgroundColor: "#080A0C",
        display: "flex",
        flexDirection: "row",
        width: width,
        minHeight: height,
        position: "absolute",
        top: 0,
        left: 0,
      }}
    >
      {drawerOpen && (
        <div
          onClick={() => setDrawerOpen(false)}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.45)",
            zIndex: 20,
          }}
        />
      )}

      <MobileModal />
      <SidebarMobile />

      <div
        style={{
          width: width,
          minHeight: "100vh",
          background: "linear-gradient(180deg, #161E29 0%, #131A23 100%)",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            display: "flex",
            height: 78,
            width: width,
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#080A0C",
            flexShrink: 0,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              width: width * 0.92,
            }}
          >
            <div
              style={{
                cursor: "pointer",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <VscThreeBars
                size={28}
                color="white"
                onClick={() => setDrawerOpen(true)}
              />
            </div>

            <div style={{ width: 28 }} />
          </div>
        </div>

        <div
          style={{
            width: "100%",
            padding: "14px",
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            gap: 14,
          }}
        >
          <div
            style={{
              ...topCardStyle,
              width: "100%",
              minHeight: headerCollapsed ? 74 : "auto",
              display: "grid",
              gridTemplateColumns: "1fr",
              position: "relative",
              transition: "min-height 0.35s ease",
            }}
          >
            <div
              onClick={() => setHeaderCollapsed(!headerCollapsed)}
              style={{
                ...headerActionIconStyle,
                position: "absolute",
                top: 12,
                right: 12,
                zIndex: 3,
              }}
            >
              {headerCollapsed ? (
                <FiChevronDown size={18} color="#F5A623" />
              ) : (
                <FiChevronUp size={18} color="#F5A623" />
              )}
            </div>

            <div
              style={{
                width: "100%",
                transition: "all 0.35s ease",
                overflow: "hidden",
                maxHeight: headerCollapsed ? 0 : 770,
                opacity: headerCollapsed ? 0 : 1,
              }}
            >
              <div
                style={{
                  width: "100%",
                  minHeight: "auto",
                  display: "grid",
                  gridTemplateColumns: "1fr",
                }}
              >
                <div
                  style={{
                    padding: 18,
                    boxSizing: "border-box",
                    display: "grid",
                    gridTemplateColumns: "1fr",
                    gap: 18,
                    alignItems: "center",
                    borderBottom: "1px solid rgba(255,255,255,0.05)",
                  }}
                >
                  <div
                    style={{
                      ...promoImageBoxStyle,
                      height: 190,
                    }}
                  >
                    <img
                      src={topLeftPromoImage}
                      alt="Try it out on android device"
                      style={promoImageStyle}
                    />
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    <div
                      style={{
                        color: "#FFFFFF",
                        fontSize: 26,
                        fontWeight: 800,
                        fontFamily: "Open Sans",
                        lineHeight: "34px",
                      }}
                    >
                      Download <span style={{ color: "#F5A623" }}>APK</span>
                    </div>

                    <div
                      style={{
                        marginTop: 10,
                        color: "#F0F0F0",
                        fontSize: 17,
                        fontWeight: 400,
                        fontFamily: "Open Sans",
                        lineHeight: "28px",
                        maxWidth: 280,
                        textAlign: 'left'
                      }}
                    >
                      Try it out on any{" "}
                      <span style={{ color: "#F5A623", fontWeight: 700 }}>
                        android
                      </span>{" "}
                      device.
                    </div>

                    <div
                      onClick={() => setApkModalOpen(true)}
                      style={{
                        ...ctaButtonStyle(true),
                        marginTop: 20,
                      }}
                    >
                      Get 7 days free trial
                      <FiChevronRight size={18} />
                    </div>

                  </div>
                </div>

                <div
                  style={{
                    padding: 18,
                    boxSizing: "border-box",
                    display: "grid",
                    gridTemplateColumns: "1fr",
                    gap: 15,
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    <div
                      style={{
                        color: "#FFFFFF",
                        fontSize: 24,
                        fontWeight: 800,
                        fontFamily: "Open Sans",
                        lineHeight: "30px",
                      }}
                    >
                      Ready to <span style={{ color: "#F5A623" }}>Transform</span>{" "}
                      ?
                    </div>

                    <div
                      style={{
                        marginTop: 12,
                        color: "#F0F0F0",
                        fontSize: 17,
                        fontWeight: 400,
                        fontFamily: "Open Sans",
                        lineHeight: "28px",
                        maxWidth: 350,
                        textAlign: 'left',
                        alignSelf: 'flex-start'
                      }}
                    >
                      Get a{" "}
                      <span style={{ color: "#F5A623", fontWeight: 700 }}>
                        free HDMI Boom stick
                      </span>{" "}
                      with every subscription!
                    </div>

                    <div
                      onClick={() => navigate("/Subscription")}
                      style={{
                        ...ctaButtonStyle(false),
                        marginTop: 20,
                      }}
                    >
                      Subscribe Now
                      <FiChevronRight size={18} />
                    </div>
                  </div>

                  <div
                    style={{
                      width: "100%",
                      maxWidth: 220,
                      height: 180,
                      justifySelf: "flex-start",
                      borderRadius: 14,
                      overflow: "hidden",
                      //   border: "1px solid rgba(255,255,255,0.08)",
                      boxShadow: "0 16px 30px rgba(0,0,0,0.3)",
                      position: "relative",
                      //   background: "#11161D",
                    }}
                  >
                    <img
                      src={topRightPromoImage}
                      alt="Free HDMI Boom Stick"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        display: "block",
                      }}
                    />
                  </div>

                </div>
              </div>

            </div>

            {headerCollapsed ? (
              <div
                style={{
                  width: "100%",
                  minHeight: 78,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "14px 58px 14px 16px",
                  boxSizing: "border-box",
                  gap: 12,
                }}
              >
                <div>
                  <div
                    style={{
                      color: "#FFFFFF",
                      fontSize: 20,
                      fontWeight: 800,
                      fontFamily: "Open Sans",
                      lineHeight: "24px",
                    }}
                  >
                    Welcome
                  </div>
                  <div
                    style={{
                      marginTop: 4,
                      color: "#B9BDC4",
                      fontSize: 13,
                      fontFamily: "Open Sans",
                    }}
                  >
                    Quick overview
                  </div>
                </div>

                <div
                  onClick={() => setApkModalOpen(true)}
                  style={{
                    ...ctaButtonStyle(true),
                    minWidth: 118,
                    height: 38,
                    fontSize: 12,
                    padding: "0 12px",
                    flexShrink: 0,
                  }}
                >
                  Free trial
                </div>
              </div>
            ) : null}
          </div>

          <div
            style={{
              width: "100%",
              marginTop: 4,
              display: "grid",
              gridTemplateColumns: "1fr",
              gap: 14,
              alignItems: "start",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  color: "#FFFFFF",
                  fontSize: 24,
                  fontWeight: 700,
                  fontFamily: "Open Sans",
                  marginBottom: 12,
                  textAlign: 'left'
                }}
              >
                Hi {displayName}
              </div>

              <div
                style={{
                  ...sectionCardStyle,
                  width: "100%",
                  padding: 14,
                }}
              >
                <div
                  style={{
                    width: "100%",
                    height: videoCardHeightMobile,
                    borderRadius: 16,
                    position: "relative",
                    overflow: "hidden",
                    background:
                      "radial-gradient(circle at center, rgba(245,166,35,0.18) 0%, rgba(245,166,35,0.03) 28%, rgba(0,0,0,0) 55%), linear-gradient(180deg, #111821 0%, #0D141D 100%)",
                    border: "1px solid rgba(255,255,255,0.08)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "height 0.35s ease",
                  }}
                >
                  {youtubeEmbedUrl ? (
                    <iframe
                      width="100%"
                      height="100%"
                      src={youtubeEmbedUrl}
                      title="Boom Display Welcome Video"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allowFullScreen
                      style={{
                        width: "100%",
                        height: "100%",
                        border: "none",
                        borderRadius: 16,
                        display: "block",
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: "84%",
                        textAlign: "center",
                        color: "#FFFFFF",
                        fontSize: 16,
                        fontFamily: "Open Sans",
                        lineHeight: "28px",
                        opacity: 0.9,
                      }}
                    >
                      Add your YouTube video URL inside{" "}
                      <span style={{ color: "#F5A623", fontWeight: 700 }}>
                        YOUTUBE_VIDEO_URL
                      </span>
                    </div>
                  )}
                </div>
              </div>

              <div style={videoDescriptionCardStyle}>
                <div style={videoDescriptionTitleStyle}>
                  <div
                    style={{
                      width: 28,
                      height: 28,
                      borderRadius: 999,
                      border: "2px solid #F5A623",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <FaPlay
                      size={10}
                      color="#F5A623"
                      style={{ marginLeft: 2 }}
                    />
                  </div>

                  <span style={{ color: "#FFFFFF", fontWeight: 800 }}>
                    Video.
                  </span>

                  <span style={{ color: "rgba(255,255,255,0.55)", fontWeight: 700 }}>
                    3:55
                  </span>
                </div>

                <div style={videoDescriptionTextStyle}>
                  Introduction of Boom Display. About whole Interface and Ai generating
                  Images and post.
                </div>
              </div>

            </div>

            <div
              style={{
                ...sectionCardStyle,
                width: "100%",
                padding: 16,
              }}
            >
              <div
                style={{
                  color: "#FFFFFF",
                  fontSize: 20,
                  fontWeight: 400,
                  fontFamily: "Open Sans",
                  marginBottom: 12,
                }}
              >
                Lets start with simple tasks
              </div>

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                  color: "#F5A623",
                  fontSize: 14,
                  fontWeight: 700,
                  fontFamily: "Open Sans",
                  marginBottom: 8,
                }}
              >
                {Math.round(progressPercent)}/100
              </div>

              <div
                style={{
                  width: "100%",
                  height: 8,
                  borderRadius: 999,
                  background: "#FFFFFF",
                  overflow: "hidden",
                  marginBottom: 16,
                }}
              >
                <div
                  style={{
                    width: `${progressPercent}%`,
                    height: "100%",
                    borderRadius: 999,
                    background: "#F5A623",
                  }}
                />
              </div>

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "column",
                  gap: 10,
                }}
              >
                {tasks.map((task, index) => (
                  <div onClick={() => {
                    if (index == 0) {
                      navigate('/Devices')
                    }
                    else if (index == 1) {
                      navigate('/Content')
                    }
                    else if (index == 2) {
                      navigate("/AISetting")
                    }
                  }} key={index} style={taskCardStyle(task.active)}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 12,
                        cursor: 'pointer'
                      }}
                    >
                      <div
                        style={{
                          width: 20,
                          height: 20,
                          borderRadius: 999,
                          border: `1.4px solid ${task.active ? "#F5A623" : "rgba(245,166,35,0.55)"
                            }`,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                          marginTop: 2,
                        }}
                      >
                        {task.active ? (
                          <div
                            style={{
                              width: 7,
                              height: 7,
                              borderRadius: 999,
                              background: "#F5A623",
                            }}
                          />
                        ) : null}
                      </div>

                      <div
                        style={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          textAlign: "left",
                        }}
                      >
                        <div
                          style={{
                            width: "100%",
                            color: "#FFFFFF",
                            fontSize: 16,
                            fontWeight: 700,
                            fontFamily: "Open Sans",
                            lineHeight: "22px",
                            textAlign: "left",
                          }}
                        >
                          {task.title}
                        </div>

                        <div
                          style={{
                            width: "100%",
                            marginTop: 5,
                            color: "#D8D8D8",
                            opacity: 0.78,
                            fontSize: 13.5,
                            fontWeight: 400,
                            fontFamily: "Open Sans",
                            lineHeight: "21px",
                            textAlign: "left",
                          }}
                        >
                          {task.desc}
                        </div>
                      </div>

                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <wc-toast></wc-toast>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    items: state._todoProduct,
  };
};

export default connect(mapStateToProps, { SetId })(Welcome);